import { RouteCategory } from './constants';

const KEYS = {
  SELECTED_ROUTES: 'CLIMBING_COMP_SELECTED_ROUTES_V1',
  SELECTED_CLIMBERS: 'CLIMBING_COMP_SELECTED_CLIMBERS_V1',
  SELECTED_ROUTE_CATEGORY: 'CLIMBING_COMP_SELECTED_ROUTE_CATEGORY_V1',
};

function write<T>(key: string, config: T) {
  try {
    localStorage.setItem(key, JSON.stringify(config));
  } catch (err) {}
}

function read<T>(key: string): T | null {
  try {
    const rawConfig = window.localStorage.getItem(key);

    if (!rawConfig) {
      return null;
    }

    const config = JSON.parse(rawConfig);

    if (config) {
      return config as T;
    }
  } catch (err) {}

  return null;
}

const storage = {
  get selectedRoutes(): SelectedRoutes | null {
    return read(KEYS.SELECTED_ROUTES);
  },
  set selectedRoutes(routes: SelectedRoutes | null) {
    write(KEYS.SELECTED_ROUTES, routes);
  },

  get selectedClimbers(): SelectedClimbers | null {
    return read(KEYS.SELECTED_CLIMBERS);
  },
  set selectedClimbers(climbers: SelectedClimbers | null) {
    write(KEYS.SELECTED_CLIMBERS, climbers);
  },

  get selectedRouteCategory(): RouteCategory | null {
    return read(KEYS.SELECTED_ROUTE_CATEGORY);
  },
  set selectedRouteCategory(category: RouteCategory | null) {
    write(KEYS.SELECTED_ROUTE_CATEGORY, category);
  },
};

export default storage;
